kombi.sign = {
    displayErrors: function (error_list, form_id, is_raw = false, add_valid_tag = false) {
        /**
         * Display the error messages in the form
         * @param {object} error_list       Object with the error messages
         * @param {string} form_id          The form id to display the errors
         * @param {boolean} is_raw          If the error_list is a django form error in html format
         * @param {boolean} add_valid_tag   Add the is-valid class to the inputs that don't have errors
         * @returns {boolean}
         */
        function parseErrorString(errorString) {
            const regex = /<li>([^<]+)<ul class="errorlist"><li>([^<]+)/g;
            const matches = {};
            let match;

            while ((match = regex.exec(errorString)) !== null) {
                const [, key, value] = match;
                if (!matches[key]) {
                    matches[key] = [];
                }
                matches[key].push(value);
            }

            return matches;
        }

        if (is_raw) {
            error_list = parseErrorString(error_list);
            console.log(error_list);
        }

        let isValid = true;
        const form = document.getElementById(form_id);
        const all_inputs = form.querySelectorAll("input, select");
        Object.keys(error_list).forEach((field) => {
            const errorMessages = error_list[field];
            const formControl = form.querySelector("[name=" + field + "]");
            formControl.classList.add("is-invalid");
            formControl.classList.add("d-block");
            const invalidFeedback = formControl.parentElement.querySelector(".invalid-feedback");
            if (invalidFeedback) {
                invalidFeedback.innerHTML = errorMessages.join("<br>");
            }
            isValid = false;
        });


        if (add_valid_tag) {
            all_inputs.forEach((input) => {
                if (!error_list.hasOwnProperty(input.name)) {
                    const formControl = form.querySelector("[name=" + input.name + "]");
                    formControl.classList.add("is-valid");
                }
            });
        }

        return isValid;
    },

    cleanValidations: function (form_id) {
        /**
         * Clean the validation classes from the form
         * @param {string} form_id The form id to clean
         * @returns {void}
         *
         */

        const form = document.getElementById(form_id);
        const all_inputs = form.querySelectorAll("input, select");
        all_inputs.forEach((input) => {
            if (input.type === "hidden") {
                return;
            }
            input.classList.remove("is-invalid");
            input.classList.remove("is-valid");
            const invalidFeedback = input.parentElement.querySelector(".invalid-feedback");
            if (invalidFeedback) {
                invalidFeedback.innerHTML = "";
            }
            const formControl = input.parentElement.querySelector(".form-control");
            if (formControl) {
                formControl.classList.remove("is-invalid");
                formControl.classList.remove("is-valid");
            }
        });
    },

    clearFormFields: function (form_id) {
        /**
         * Clear the form fields
         * @param {string} form_id The form id to clear
         * @returns {void}
         *
         */
        const form = document.getElementById(form_id);
        form.classList.remove("was-validated");
        form.__disabled = false;
        const all_inputs = form.querySelectorAll("input, select");
        all_inputs.forEach((input) => {
            if (input.type === "hidden") {
                return;
            }
            input.value = "";
            input.classList.remove("is-invalid");
            input.classList.remove("is-valid");
        });
    },

    emailValidation: function (email) {
        if (email.trim() === '') {
            return false;
        }
        const emailReg = /^([\w-.+]+@([\w-]+\.)+[\w-]{2,10})?$/;
        return emailReg.test(email);
    },
}